import Vue from 'vue';
import SkySvg from './sky-svg';

Vue.component('sky-svg', SkySvg);

export default SkySvg;



// WEBPACK FOOTER //
// ./scripts/sky-svg/index.js